import { BaseApi } from '@/main/baseApi';

import {
	DependentTableNames,
	DMS_MODULE,
	NAME,
} from './constants';
import { BULK_INVENTORY_ADJUSTMENT_APPROVAL } from '../constants';

class BulkInventoryAdjustmentApprovalProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case BULK_INVENTORY_ADJUSTMENT_APPROVAL:
				return `/${DMS_MODULE}/${BULK_INVENTORY_ADJUSTMENT_APPROVAL}/Schema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case BULK_INVENTORY_ADJUSTMENT_APPROVAL:
				return `/${DMS_MODULE}/${BULK_INVENTORY_ADJUSTMENT_APPROVAL}/Rows`;
			default:
				throw new Error(`data for ${tableName} is not implemented yet`);
		}
	}

	bulkInventoryApproveReject(StatusId: null | number, WarehouseId: null | number, Approved1OrReject2: null | number, RejectedComments: string) {
		return this.post(`/${DMS_MODULE}/${NAME}/ApproveDetails?Id=${StatusId}&WarehouseId=${WarehouseId}&Approved1OrReject2=${Approved1OrReject2}&RejectedComments=${RejectedComments}`);
	}

	async saveInventoryAdjusments(dto: any) {
		return this.post(`/${DMS_MODULE}/${'NdSklad'}/InventoryAdjusments`, dto);
	}

	async approveInventoryAdjustment(dto: any) {
		return this.post(`/${DMS_MODULE}/${'NdSklad'}/ApproveRejectInventoryAdjustment`, dto);
	}

	async sendNotification(dto: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendNotification`, dto);
	}

	async getWorkflowApprovalConfig(approvaltype: string, approvallevel: string) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetWorkflowApprovalConfig?approvaltype=${approvaltype}&approvallevel=${approvallevel}`);
	}

	async sendEmailNotification(dto: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendMailNotification`, dto);
	}
}

export const apiProvider = new BulkInventoryAdjustmentApprovalProvider(DMS_MODULE, NAME);
